import { Injectable } from '@angular/core';
import {SharedModule} from '../shared.module';
import { Store} from '@ngrx/store';
import * as fromShared from '../reducers';
import {PlayerConfigurationEdit} from '../models/player-configuration';
import { InputTypes, PlayerConfigurationDefinition} from '../models/player-config-list-option';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Config, GroupConfigs} from '../models/config';
import {IsUsedPlayerConfigurationDefinitionAction} from '../actions/player-configuration-definition';
import {IP_PATTERN, NUMERIC_PATTERN, TIME_PATTERN} from '../consts';
import * as _ from 'lodash';

@Injectable({providedIn: SharedModule})
export class PlayerConfigurationService {


  constructor( private store: Store<fromShared.AppState>) {}

  getForm(form: FormGroup , configEdit: PlayerConfigurationEdit[] , configDefinition: PlayerConfigurationDefinition[]): FormGroup {
    if (configEdit && configDefinition) {
      configEdit.forEach((playerConfig: PlayerConfigurationEdit) => {
        configDefinition.forEach((def: PlayerConfigurationDefinition) => {
          if (def.name === playerConfig.key) {
            this.addControl(form , def, playerConfig.value);
          }
        })
      });
    }
    return form;
  }

  /**
   * cette fonction ajoute le controlleur et les validateur au formulaire
   *
   */
  addControl(form: FormGroup , def: PlayerConfigurationDefinition , playerConfigValue: string): FormGroup {
    if (InputTypes[def.inputType] === 'number') {
      form.addControl(def.name, new FormControl(playerConfigValue,
        [Validators.required, Validators.pattern(NUMERIC_PATTERN)]))
    } else if (def.inputConstraint === 1) {
      form.addControl(def.name, new FormControl(playerConfigValue ,
        [Validators.required, Validators.min(def.inputConstraintParam1) , Validators.max(def.inputConstraintParam2)]))
    } else if (def.inputConstraint === 3) {
      form.addControl(def.name, new FormControl(playerConfigValue ,
        [Validators.required, Validators.pattern(IP_PATTERN)]))
    } else if (InputTypes[def.inputType] === 'time') {
      form.addControl(def.name, new FormControl(playerConfigValue,
        [Validators.required, Validators.pattern(TIME_PATTERN)]))
    } else if (InputTypes[def.inputType] === 'checkBox') {
        form.addControl(def.name, new FormControl( playerConfigValue ? playerConfigValue : true ,
          [Validators.required]))

    } else {
      form.addControl(def.name, new FormControl(playerConfigValue , Validators.required))
    }
    return form;
  }

  getGroupConfigs(groupConfigs: GroupConfigs , configEdit: PlayerConfigurationEdit[] , configDefinition: PlayerConfigurationDefinition[]): GroupConfigs {
     const config = _.cloneDeep(groupConfigs.groupConfigs[0].config);
     if (configEdit && configDefinition) {
      configEdit.forEach((playerConfig: PlayerConfigurationEdit) => {
        configDefinition.forEach((def: PlayerConfigurationDefinition) => {
          if (def.name === playerConfig.key) {
            this.creationOfConfig(config , def, playerConfig.value);
          }
        })
       });
     }
     groupConfigs.groupConfigs[0].config = config;
     return groupConfigs;
  }
  /**
   * cette fonction ajoute la config pour le nouvelle element demander
   *
   */

  creationOfConfig(config: Config[] , def: PlayerConfigurationDefinition , playerConfigValue: string): Config[] {
    this.store.dispatch(new IsUsedPlayerConfigurationDefinitionAction({name: def.name, value: true}));
    config.push({
      type: this.getInputType(def.inputType)  ,
      label: def.name,
      controlName: [def.name],
      placeholder: def.name,
      presentation: def.editionMode === 2 ? 'edit' : 'detail', // pas de no
      options: {
        hideAll: def.editionMode === 1 ? 'notDisplay' : 'show',
        show: true,
        labelPosition: InputTypes[def.inputType] === 'checkBox' ? 'left' : null,
        labelShowInDetail: true,
        value: (!def.defaultValue && def.defaultValue !== 'true' ) ? playerConfigValue : def.defaultValue,
        inputOptions: true,
      }
    })
    return config;
  }

  getInputType(inputType: number): string {
    if (InputTypes[inputType] === 'number' || InputTypes[inputType] === 'time' || InputTypes[inputType] === 'select') {
      return 'input';
    } else {
        return  InputTypes[inputType];
    }
  }
}
